export enum FeatureWrapperColumnsModes {
  Default = '2.5fr 1fr',
  Mode1 = '1.5fr 1fr',
}
